import { LoungeMaintenanceConfig } from '../utils/loungeMaintenance';
import { LoungeHeader } from './LoungeHeader';
import { MobileLoungeHeader } from './MobileLoungeHeader';

type LoungeMaintenanceScreenProps = {
  config: LoungeMaintenanceConfig;
  checking?: boolean;
};

export function LoungeMaintenanceScreen({
  config,
  checking = false,
}: LoungeMaintenanceScreenProps) {
  const title = checking ? 'Checking Lounge status' : config.title;
  const message = checking
    ? 'One moment while we confirm the current Lounge write status.'
    : config.message;

  return (
    <div className='mid-main mw-maintenance-page'>
      <div className='container'>
        <div className='mid-sec'>
          <LoungeHeader />
          <MobileLoungeHeader />

          <div className='mid-card-sec'>
            <section
              className='mw-maintenance-card'
              role='status'
              aria-live='polite'
            >
              <div className='mw-maintenance-kicker'>Write freeze</div>
              <h1>{title}</h1>
              <p>{message}</p>
              {!checking && config.eta && (
                <p className='mw-maintenance-eta'>{config.eta}</p>
              )}
              <div className='mw-maintenance-actions'>
                <button
                  type='button'
                  className='mw-maintenance-refresh'
                  onClick={() => window.location.reload()}
                >
                  Refresh
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoungeMaintenanceScreen;
